import React from 'react';

/** Purple ID badge used in list tables (Levels, Branches, Enrollments, etc.). */
export default function ListRecordIdBadge({ id }) {
    if (id == null || id === '') {
        return <span className="text-gray-400">—</span>;
    }

    return (
        <span className="inline-flex items-center justify-center min-w-[2rem] px-2.5 py-1 rounded-lg bg-gradient-to-r from-purple-100 to-indigo-100 text-purple-800 text-sm font-semibold border border-purple-200">
            {id}
        </span>
    );
}
